export const permissoes = [
  {
    label: "Adicionar clientes",
    assessor: true,
    gerente: true,
    admin: true,
  },
  {
    label: "Enviar DARFs automaticamente",
    assessor: true,
    gerente: true,
    admin: true,
  },
  {
    label: "Contratar plano via cartão de crédito",
    assessor: true,
    gerente: true,
    admin: true,
  },
  {
    label: "Contratar planos via concierge",
    assessor: false,
    gerente: true,
    admin: true,
  },
  {
    label: "Adicionar novos assessores",
    assessor: false,
    gerente: false,
    admin: true,
  },
  {
    label: "Visualizar e editar informações dos clientes",
    assessor: false,
    gerente: false,
    admin: true,
  },
  {
    label: "Visualizar e editar informações dos assessores",
    assessor: false,
    gerente: false,
    admin: true,
  },
  {
    label: "Visualização das faturas mensais consolidadas",
    assessor: false,
    gerente: false,
    admin: true,
  },
];
